import { cartDetailsFragment } from '../queries/get-cart-query'

const cartLinesUpdateMutation = /* GraphQL */ `
  mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
    cartLinesUpdate(cartId: $cartId, lines: $lines) {
      userErrors {
        code
        field
        message
      }
      cart {
        ...cartDetails
      }
    }
  }

  ${cartDetailsFragment}
`
export default cartLinesUpdateMutation
